import {
  getProductDiscount,
  getProductPriceInSells,
} from "../../../_utils/utils";

export const groupAccesoriesAndTotalSells = (productArray) => {
  let barCodeKey = {};
  let total = 0;
  let result = {};

  productArray.forEach((value) => {
    /** calculate total sells */
    const price = getProductPriceInSells(value);
    const discount = getProductDiscount(value);
    total += price - discount;

    /** group accesories by bar code */
    if (value.product?.accesory) {
      const {
        product: { accesory },
      } = value;

      if (barCodeKey[accesory?.barCode]) {
        const { barCode, discount = 0, price } = accesory;
        const counterProducts = (barCodeKey[barCode].counter += 1);

        barCodeKey[barCode].product.accesory.price += price;
        barCodeKey[barCode].product.accesory.discount += discount;
        barCodeKey[barCode].payment_method.name = counterProducts;
        barCodeKey[barCode].createdAt = undefined;

        barCodeKey[barCode] = {
          ...barCodeKey[barCode],
          counter: counterProducts,
        };
      } else {
        const { barCode } = accesory;
        barCodeKey[barCode] = {
          ...value,
          counter: 1,
        };
      }
    }
  });

  if (Object.values(barCodeKey).length) {
    let tempData = [...productArray];
    const barCodeArray = Object.keys(barCodeKey);
    // console.log("accesoriesGroupByBarCode", barCodeArray);

    barCodeArray.forEach((barCode) => {
      let i = tempData.length;
      while (i--) {
        if (tempData[i].product?.accesory?.barCode === barCode) {
          tempData.splice(i, 1);
        }
      }
    });

    tempData = [...tempData, ...Object.values(barCodeKey)];
    //console.log("tempData", tempData);
    result = { totalSales: total, salesArray: tempData };
  } else result = { totalSales: total, salesArray: productArray };
  return result;
};
